import {AnimationMixer, PerspectiveCamera, Scene, Timer, Vector3, WebGLRenderer} from 'three';
import { HandTrackingResult, PostProcessingConfig, SceneManagerInterface } from './SceneManagerInterface';
import PhysicsHandler from '../physics/cannon/PhysicsHandler';
import { SceneHelper } from './SceneHelper';
import HandPoseManager from '../hands/HandPoseManager';
import AmmoHandler from "../physics/ammo/AmmoHandler";

export default class SceneManagerParent implements SceneManagerInterface {
  protected scene: Scene;
  protected sceneHelper: SceneHelper;
  protected physicsHandler: PhysicsHandler;
  protected ammoHandler: AmmoHandler;
  protected renderer: WebGLRenderer;
  protected camera: PerspectiveCamera;
  protected handPoseManager: HandPoseManager;
  protected timer = new Timer();
  protected mixer: AnimationMixer;

  build(camera, scene, renderer, physicsHandler: PhysicsHandler) {
    this.scene = scene;
    this.sceneHelper = new SceneHelper(scene);
    this.physicsHandler = physicsHandler;
    this.renderer = renderer;
    this.camera = camera;
    this.handPoseManager = new HandPoseManager(scene, physicsHandler);
    this.ammoHandler = new AmmoHandler(scene);
  }

  getInitialCameraAngle(): number {
    return 0;
  }

  getInitialCameraPosition(): Vector3 {
    return undefined;
  }

  getInitialCameraTarget(): Vector3 {
    return undefined;
  }

  handleGesture(gesture: HandTrackingResult) {
  }

  postUpdate() {
  }

  getPostProcessingConfig(): PostProcessingConfig {
    return undefined;
  }

  isDepthEnabled(): boolean {
    return false;
  }

  setAmmoHandler(ammoHandler: AmmoHandler) {
    this.ammoHandler = ammoHandler;
  }

  update() {
    this.timer.update();
  }

}
